module.exports = __webpack_public_path__ + "static/media/girl3.0783f697.svg";